import { render, staticRenderFns } from "./dialog-addrelation.vue?vue&type=template&id=7c51df4d&"
import script from "./dialog-addrelation.vue?vue&type=script&lang=js&"
export * from "./dialog-addrelation.vue?vue&type=script&lang=js&"
import style0 from "./dialog-addrelation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports